import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgCheckmarkInverted20 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" sx={{
    ...sx
  }} {...other}><path d="M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0m5.267 5.08-8.009 7.674-2.527-2.595a.3.3 0 0 0-.43 0l-1.216 1.248a.313.313 0 0 0-.004.438l3.966 4.071c.117.12.31.123.436 0l9.425-9.14a.312.312 0 0 0 .01-.439L15.702 5.09a.315.315 0 0 0-.435-.01" className="checkmark-inverted-20_svg__path-1" /></SvgIcon>;
};
const Memo = memo(SvgCheckmarkInverted20);
export default Memo;